import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload"
import { useOrderImportCSV } from "../../../api/queries/useOrderImportCSV"
import { Button } from "primereact/button"
import { ReactNode, SyntheticEvent, useState } from "react"
import { OrderImportCSVResponse, OrderImportCSVRowResponse, OrderImportCSVRowTextErrorResponse } from "../../../api/types/order"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"

export const OrderImportCSV = () => {
  const orderImportCSV = useOrderImportCSV()

  const [file, setFile] = useState<string>("")
  const [name, setName] = useState<string>("")
  const [res, setRes] = useState<OrderImportCSVResponse | null>(null)

  const reset = () => {
    setFile("")
    setName("")
    setRes(null)
  }

  const onFileUpload = async (event: FileUploadHandlerParam) => {
    const reader = new FileReader()

    reader.onload = () => {
      setFile(reader.result as string)
    }

    setName(event.files[0].name)
    reader.readAsDataURL(event.files[0])
  }

  const onSubmit = async (event: SyntheticEvent) => {
    event.preventDefault()

    const res = await orderImportCSV.mutateAsync({ file })

    setRes(res)
  }

  const tCode = (row: OrderImportCSVRowResponse): string => row.code

  const tRow = (row: OrderImportCSVRowResponse): string => `${row.line}`

  const tText = (row: OrderImportCSVRowResponse): ReactNode =>
    row.texts.some(text => Boolean(text.errors))
      ? <i className="pi pi-times" style={{ color: "var(--red-500)" }} />
      : <i className="pi pi-check" style={{ color: "var(--green-500)" }} />

  const tError = (row: OrderImportCSVRowTextErrorResponse): string => row.text

  const rowExpansionTemplate = (row: OrderImportCSVRowResponse) => {
    return row.texts.map(text => (
      <div className="col-12" key={text.text}>
        <DataTable
          emptyMessage={"Žádné záznamy"} className={"p-datatable-sm"}
          paginator={false} value={text.errors} stripedRows={true}
        >
          <Column header={text.text} body={tError} />
        </DataTable>
      </div>
    ))
  }

  if (res) {
    return (
      <>
        <div className={"col-12"}>
          <div className={"flex align-items-center"}>
            <Button label={"Nový import"} title="Nový import"
              icon={"pi pi-upload"} onClick={() => reset()}
              className={"p-button p-button-primary p-button-sm p-button-responsive mr-3"} />
          </div>
        </div>

        <div className={"col-12"}>
          <DataTable
            emptyMessage={"Žádné záznamy"} className={"p-datatable-sm"}
            paginator={false}
            expandedRows={res.results.rows.filter(row => row.texts.some(text => Boolean(text.errors)))}
            rowExpansionTemplate={rowExpansionTemplate} value={res.results.rows} stripedRows={true}
          >
            <Column header={"Název"} body={tCode} />

            <Column header={"Řádek"} body={tRow} />

            <Column header={"Status"} body={tText} />
          </DataTable>
        </div>
      </>
    )
  }

  return (
    <div className={"col-12"}>
      <form onSubmit={onSubmit}>
        <div className={"p-fluid"}>
          <div className={"border-round-top flex block-title block-title_blue align-items-center px-3"}>
            CSV import objednávek
          </div>

          <div className={"border-solid border-1 border-300 px-3 pt-4 mb-6"}>
            <div className={"grid"}>
              <div className={"field col-12 md:col-4"}>
                <span className={"p-float-label"}>
                  <FileUpload mode="basic" name="file" customUpload={true} uploadHandler={onFileUpload}
                    accept="text/csv" auto={true} chooseLabel={name || "Vybrat"}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className={`md:flex`}>
          <span className={"flex-1 text-right"}>
            <Button type={"submit"} label={"Odeslat"}
              className={"p-button p-button-sm p-button-success"}
              disabled={orderImportCSV.isLoading || !file}
              icon={orderImportCSV.isLoading ? "pi pi-spinner pi-spin" : "pi pi-upload"} />
          </span>
        </div>
      </form>
    </div>
  )
}
